/**
 * "Terakhir Dilihat" di beranda: simpan slug produk yang dibuka pembeli di
 * localStorage (tanpa query tambahan). Inti logika murni (pushRecentSlug,
 * matchRecentProducts) dipisah dari wrapper browser supaya bisa diuji di node.
 */

export const RECENT_VIEWS_KEY = "galea-preorder-recent";
export const RECENT_VIEWS_MAX = 12;

/**
 * Produk baru dicatat setelah benar-benar DILIHAT selama ini (ms). Sejak
 * halaman produk bisa digeser ke produk berikutnya, pembeli bisa melewati
 * belasan produk dalam semenit — tanpa jeda, rail 12 slot ini penuh oleh
 * produk yang cuma dilewati dan mendorong keluar yang sengaja ia buka.
 */
export const RECENT_VIEW_DWELL_MS = 2000;

/** Dedupe + move-to-front + potong max. Slug kosong diabaikan. */
export function pushRecentSlug(
  list: string[],
  slug: string,
  max = RECENT_VIEWS_MAX
): string[] {
  const trimmed = slug.trim();
  if (!trimmed) return list.slice(0, max);
  return [trimmed, ...list.filter((item) => item !== trimmed)].slice(0, max);
}

/** Cocokkan slug tersimpan dengan produk termuat; urutan recency dipertahankan. */
export function matchRecentProducts<T extends { slug: string }>(
  slugs: string[],
  products: T[]
): T[] {
  const bySlug = new Map(products.map((product) => [product.slug, product]));
  return slugs
    .map((slug) => bySlug.get(slug))
    .filter((product): product is T => Boolean(product));
}

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === "string");
}

/** Baca slug tersimpan; tak pernah throw (localStorage penuh/JSON korup → []). */
export function readRecentSlugs(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(RECENT_VIEWS_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return isStringArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Catat kunjungan produk (dipanggil dari ProductDetail); best-effort, tak pernah throw. */
export function recordRecentView(slug: string): void {
  if (typeof window === "undefined") return;
  try {
    const next = pushRecentSlug(readRecentSlugs(), slug);
    window.localStorage.setItem(RECENT_VIEWS_KEY, JSON.stringify(next));
  } catch {
    // abaikan — fitur opsional
  }
}
